<template>
  <v-data-table
    class="order_add_table"
    hide-default-footer
    :items="items"
    :headers="headers"
    disable-pagination
  >
    <template #item.productName="{ item }">
      {{ item.productName }}
      <v-chip v-if="item.canToChange" small>{{ $t("new") }}</v-chip>
    </template>
    <template #item.productGroupName="{ item }">
      {{ item.productDescription }}
    </template>
    <template #item.productTypeName="{ item }">
      {{ item[`product_type_${$i18n.locale}`] }}
    </template>
    <template #item.unitTypeName="{ item }">
      {{ item[`unit_type_name_${$i18n.locale}`] }}</template
    >
    <template #item.count="{ item }">
      <div v-if="item.isChanging">
        <div class="d-flex">
          <custom-input-text
            type="number"
            min="1"
            @blur="onBlurFromCountInput(item)"
            :max="item.oldCount"
            v-model="item.tempCount"
            class="user_input no-margin"
          ></custom-input-text>
          <v-btn class="btn_33 plus_btn" @click="apply(item)">
            <vue-icon icon="checkIcon" />
          </v-btn>
          <v-btn class="btn_33 delete_btn" @click="item.isChanging = false">
            <vue-icon icon="rejectIcon" />
          </v-btn>
        </div>
        <p v-if="+item.oldCount - +item.tempCount > 0">
          {{
            $t("willBeAddedToNewRequest", [+item.oldCount - +item.tempCount])
          }}
        </p>
      </div>

      <div
        :class="{ 'cursor-pointer': item.canToChange }"
        @click="
          () => {
            if (item.canToChange) item.isChanging = true;
          }
        "
        v-else
      >
        <span class="font-weight-bold">{{ item.count }}</span>
      </div>

      <span v-show="item.changed">
        {{ $t("willBeAddedToNewRequest", [+item.oldCount - +item.tempCount]) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "OzlOrderEditableCountTable",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    onBlurFromCountInput(item) {
      if (+item.tempCount < 1 || +item.oldCount < item.tempCount) {
        item.count = item.oldCount;
        item.tempCount = item.oldCount;
      }
    },
    apply(item) {
      this.onBlurFromCountInput(item);
      if (+item.count !== +item.tempCount) {
        item.changed = true;
      }
      if (+item.tempCount === +item.oldCount) item.changed = false;
      item.count = item.tempCount;
      item.isChanging = false;
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("product"),
          value: "productName",
        },
        { text: this.$t("categoryTMC"), value: "productTypeName" },
        { text: this.$t("attributes"), value: "productGroupName" },
        { text: this.$t("measureShort"), value: "unitTypeName" },
        { text: this.$t("countShort"), value: "count" },
      ];
    },
  },
};
</script>
